// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"styles_horizontal__2TWgi","vertical":"styles_vertical__oMv54"};